/**
 * Print History Model
 * สำหรับบันทึกประวัติการพิมพ์ใบส่งของและใบปะหน้า
 * (เฉพาะ Premium และ Enterprise packages)
 */

/**
 * Create Print History Model
 */
export const createPrintHistoryModel = (data) => {
  return {
    storeId: data.storeId || '',
    orderId: data.orderId || null, // null สำหรับ Store Label
    printType: data.printType || 'shipping_label', // 'shipping_label' | 'store_label'
    templateType: data.templateType || 'sticker', // 'sticker' | 'a4' | 'compact'
    
    // ข้อมูลที่พิมพ์
    printData: data.printData || {}, // ข้อมูลที่พิมพ์ (order, store info, etc.)
    
    // Metadata
    printedBy: data.printedBy || '', // userId
    printedAt: data.printedAt || new Date(),
    
    // ข้อมูลเพิ่มเติม
    notes: data.notes || '',
    
    createdAt: data.createdAt || new Date(),
    updatedAt: new Date()
  };
};

/**
 * Print Types
 */
export const PRINT_TYPES = {
  SHIPPING_LABEL: 'shipping_label',
  STORE_LABEL: 'store_label',
  PACKING_SLIP: 'packing_slip'
};

/**
 * Template Types
 */
export const TEMPLATE_TYPES = {
  STICKER: 'sticker',
  A4: 'a4',
  COMPACT: 'compact'
};

